export function toArray<T>(responseList: { [key: string]: T }): T[] {
  const keys = Object.keys(responseList);
  return keys.map((k) => {
    const item: T = responseList[k];
    return { ...(item as any), id: k };
  });
}
